export default __webpack_public_path__ + "static/media/2087.e6935adf.png";